import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, LinearProgress } from '@mui/material';
import React, { Component } from "react";
import { connect } from 'react-redux';
import { showMessage } from '../../actions/uiActions';
import { forgivenessType, perkinsCancellation } from '../Archive/forgvenessType';
import AdministratorsApi from "../../api/administrators"

class ForgivenessModal extends Component {
    state = {
        processing: false,
        reason_description: '',
        forgiven_amount: 0,
        forgiven_date: null,
        forgiveness_type: "",
    }

    componentDidMount() {
        const { forgiveness } = this.props;

        if (forgiveness) {
            const forgiven_date = new Date(forgiveness.dateReceived);
            this.setState({
                forgiveness_type: forgiveness.type.toLowerCase(),
                forgiven_amount: forgiveness.amount,
                forgiven_date: forgiven_date.toISOString().split('T')[0],
                reason_description: forgiveness.description
            })
        }
    }

  
    handleSubmit = async () => {
        const { userId, showMessage, onClose, onSuccess, forgiveness } = this.props;
        const { reason_description, forgiven_amount,forgiveness_type, forgiven_date } = this.state;

        try {
            if (forgiven_amount <= 0 || forgiveness_type === "" || forgiven_date  === "" ) {
                 showMessage("Kindly provide all forgiveness details before submitting.");
                return;
            }
            const payload = {
                reason_description,
                forgiven_amount,
                forgiven_date,
                forgiveness_type,
                category: "partial"
            }
            this.setState({ processing: true })
            if (forgiveness) {
                await AdministratorsApi.updateForgiveness(userId, forgiveness._id, payload)
                showMessage('User forgiveness has been updated');
            } else {
                await AdministratorsApi.addForgiveness(userId, payload)
                showMessage('User forgiveness has been added');
            }
            this.setState({ processing: false })
            onSuccess()
            onClose()
            
        } catch (error) {
            this.setState({ processing: false })
             showMessage(error.message);
        }
    }

    handleChanges = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    render() {
        const { onClose } = this.props;
        const {forgiveness_type,  processing, reason_description, forgiven_amount, forgiven_date } = this.state;
        return (
            <Dialog
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                open={true}
                onClose={onClose}
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">Record partial forgiveness for this borrower</DialogTitle>
                <DialogContent>
                <DialogContentText>Forgiveness can be partial or total</DialogContentText>
                    <br />
                   
                        <>
                            <div className="form-group nice">
                                <label>Forgiveness Type:</label>
                                <select
                                    name="forgiveness_type"
                                    onChange={this.handleChanges}
                                    value={forgiveness_type}
                                    disabled={processing}
                                    className="form-control"
                                >
                                    <option value="">Select...</option>
                                    {[...forgivenessType, perkinsCancellation].map(({ value, label }) => (
                                        <option value={value} key={value}>{label}</option>
                                    ))}
                                </select>
                            </div>
                        
                            <div className="form-group nice">
                                <label>Forgiveness Amount:</label>
                                <input
                                    disabled={processing}
                                    type="number"
                                    className="form-control"
                                    placeholder="Forgiveness Amount"
                                    name="forgiven_amount"
                                    value={forgiven_amount}
                                    onChange={this.handleChanges}
                                />
                            </div>
                            <div className="form-group nice">
                                <label>Forgiveness Date:</label>
                                <input
                                    disabled={processing}
                                    type="date"
                                    className="form-control"
                                    placeholder="Forgiveness Date"
                                    name="forgiven_date"
                                    value={forgiven_date}
                                    onChange={this.handleChanges}
                                    min="2020-01-01"
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                        </>
                        
                    <div className="form-group nice">
                        <label>Give more details:</label>
                        <textarea
                            type="text"
                            className="form-control"
                            value={reason_description}
                            onChange={this.handleChanges}
                            name="reason_description"
                            placeholder="Give more details"
                        ></textarea>
                    </div>
                    {processing && <LinearProgress />}
                </DialogContent>
                {!processing && (
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={this.handleSubmit}
                            color="primary"
                            autoFocus
                        >
Submit                        </Button>
                        <Button onClick={onClose} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                )}
            </Dialog>
        )
    }
}
export default connect(null, { showMessage })(ForgivenessModal);